<template>
    <div>
        <el-dialog
            title="添加文章"
            :visible.sync="showdialog"
            width="1200px"
            v-dialogDrag
            :before-close="close">
            <el-form :model="form" ref="form" label-width="80px" :inline="false" size="mini">
               <el-form-item label="城市" v-if="isAllCity">
                    <el-select v-model="selectedCity" placeholder="选择城市" size="mini">
                        <el-option :label="city.label" :value="city.label" v-for="(city, index) in cityList" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择类型">
                    <el-radio v-model="form.types" label="动态">资讯</el-radio>
                    <el-radio v-model="form.types" label="点评">点评</el-radio>
                </el-form-item>
                <el-form-item label="一句话点评" v-if="form.types=='点评'">
                    <el-input v-model="form.short" maxlength="30" placeholder="列表页的一句话点评"></el-input>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="form.title" maxlength="50" placeholder="5-50字的标题"></el-input>
                </el-form-item>
                <el-form-item label="缩略图">
                    <el-upload
                        class="avatar-uploader"
                        action="/api/Upload/uploadFile/"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess">
                        <img v-if="form.thumbnail" :src="form.thumbnail" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="内容">
                    <tin-editor class="tin-editor" @input="getcontent"></tin-editor>
                </el-form-item>
                <el-form-item label="视频封面" prop="videoCover">
                    <el-upload class="avatar-uploader" action="/api/Upload/uploadfilevsnologo/" :show-file-list="false"
                      :on-success="handleAvatarMovieSuccess" :before-upload="beforeAvatarUpload">
                      <img v-if="form.videoCover" :src="form.videoCover" class="videoCoverimg">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="视频上传">
                    <el-upload ref="myVideo" class="avatar-uploader el-upload--text" name="file"
                      action="/api/Upload/uploadfilevsnologo/" :show-file-list="false" :on-success="handleVideoSuccess"
                      :before-upload="beforeUploadVideo" :on-progress="uploadVideoProcess">
                      <video v-if="videoForm.storageurl != '' && videoFlag == false" :src="videoForm.storageurl"
                        class="avatar" controls="controls">
                        您的浏览器不支持视频播放
                      </video>
                      <i v-else-if="videoForm.storageurl == '' && videoFlag == false"
                        class="el-icon-plus avatar-uploader-icon" />
                      <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent"
                        style="margin-top:30px;" />
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="finish">保存</el-button>
                    <el-button @click="showdialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import TinEditor from '../../../components/tin-editor.vue'
export default {
    components: {
        TinEditor,
    },
    data() {
        return{
            showdialog: true,
            videoForm: {
                storageurl: ''
            },
            form: {
                types: '动态',
                short: '',
                title: '',
                thumbnail: '',
                content: '',
                videoCover: null,            //视频封面
                videoUrl: '',         //视频地址
            },
            id: '',
            selectedCity:'武汉',
            cityList:this.$store.getters.getcitylist,
            isAllCity:true,
            videoFlag: false,
        }
    },
    mounted(){
        let selectedCity = this.$route.query.selectedCity;
        if(selectedCity) this.selectedCity = selectedCity;
        let isAllCity = this.$route.query.isAllCity;
        if(isAllCity === 'false') this.isAllCity = false;
        if(!this.cityList.length){
            this.getCityList();
        }
    },
    methods: {
        getCityList() {
            this.$api.getCityList("").then((data) => {
                this.cityList = data;
                this.$store.commit('setcitylist', data);
            });
        },
        getcontent(content) {
            this.form.content = content;
        },
        close() {
            this.$confirm('内容未保存，是否确定关闭?')
                .then(_=>{
                    this.$router.go(-1);
                })
        },
        finish() {
            this.confirm();
        },
        // save() {
        //     var params = {
        //         id: this.id,
        //         types: this.form.types,
        //         short: this.form.short||'',
        //         title: this.form.title,
        //         thumbnail: this.form.thumbnail,
        //         content: JSON.stringify(this.form.content),
        //     }
        //     this.$api.editProjectExpertRemark(params).then(
        //         data=>{
        //             this.$message.success(data);
        //             this.$router.go(-1);
        //         }
        //     )
        // },

        beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      // const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isPNG) {
        this.$message.error('只能上传图片，不能上传其他文件!');
      }
      // if (!isLt2M) {
      //     this.$message.error('上传的图片大小不能超过 1MB!');
      // }

      return isJPG || isPNG;
    },
    // 验证视频格式
    beforeUploadVideo (file) {
      // 获取视频时长

      console.log(file)
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb'
        ].indexOf(file.type) === -1
      ) {
        this.$message.error('请上传正确的视频格式')
        return false
      }
      // 主要代码模块
      // 获取视频时长
      const url = URL.createObjectURL(file)
      const audioElement = new Audio(url)
      let duration
      const fun = (duration) => {
        this.durationtime = duration
      }
      // 下面需要注意的是在监听loadedmetadata绑定的事件中对duration直接进行赋值是无效的，需要在fun回调函数中进行赋值
      audioElement.addEventListener('loadedmetadata', function () { // 音频/视频的元数据已加载时，会发生 loadedmetadata 事件
        duration = audioElement.duration // 时长以秒作为单位
        fun(parseFloat(duration).toFixed(1))
      })
    },
    // 上传进度显示
    uploadVideoProcess (event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = Math.floor(event.percent)
    },
    // 获取上传视频地址
    handleVideoSuccess (res, file) {
      console.log(res, file)
      this.videoFlag = false
      this.videoUploadPercent = 0
      if (res.msg === '上传成功') {
        this.videoForm.storageurl = res.data
        this.form.videoUrl = this.videoForm.storageurl
      } else {
        this.$message.error('视频上传失败，请重新上传！')
      }
    },
        confirm() {
            var params = {
                types: this.form.types,
                short: this.form.short||'',
                title: this.form.title,
                thumbnail: this.form.thumbnail,
                content: JSON.stringify(this.form.content),
                city:this.selectedCity,
                videoCover:this.form.videoCover,
                videoUrl:this.form.videoUrl
            }
            this.$api.addProjectDynamic(params).then(
                data=>{
                    let {msg, id} = data;
                    this.id = id;
                    this.$message.success(msg);
                    this.$router.go(-1);
                    // this.showdialog = false;
                }
            )
        },
        handleAvatarSuccess(e) {
            let {data, errCode, msg} = e;
            if (data){
                this.$message.success(msg);
                this.form.thumbnail = data;
            } else {
                this.$message.error(msg);
            }
        },
        handleAvatarMovieSuccess(e) {
            let {data, errCode, msg} = e;
            if (data){
                this.$message.success(msg);
                this.form.videoCover = data;
            } else {
                this.$message.error(msg);
            }
        },
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG  = file.type === 'image/png';
            // const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isJPG&&!isPNG) {
                this.$message.error('只能上传图片，不能上传其他文件!');
            }
            // if (!isLt2M) {
            //     this.$message.error('上传的图片大小不能超过 1MB!');
            // }

            return isJPG||isPNG;
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
::v-deep .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 100px;
    display: block;
}
// .editor {
//     line-height: normal !important;
//     height: 300px;
// }
::v-deep .ql-container{
    height: 600px;
}
.upload-demo{
    display: none;
}
.tin-editor{
    width: 100%;
}
.videoCoverimg {
  width: 200px;
  height: 200px;
}
</style>